import localForage from 'localforage';
import logger from './logger';
import { decryptData, encryptData } from './encryption';

const getStorageAvailable = () => {
  if (window?.localStorage) {
    return 'localStorage';
  }
  if (window?.indexedDB) {
    return 'indexedDB';
  }
  if (window?.sessionStorage) {
    return 'sessionStorage';
  }

  return 'noStorage';
};

const availableStorage = getStorageAvailable();

export const saveStore = async (data, nameKey) => {
  logger({ title: 'STORAGE', subtitle: 'saveStore availableStorage', data: { availableStorage } });
  if (availableStorage === 'noStorage') return;
  const encryptedData = encryptData(JSON.stringify(data));
  if (availableStorage === 'sessionStorage') {
    window[availableStorage].setItem(nameKey, encryptedData);
  } else {
    await localForage.setItem(nameKey, encryptedData);
  }
};

export const getStore = async (nameKey) => {
  if (availableStorage === 'noStorage') return null;
  let data;
  if (availableStorage === 'sessionStorage') {
    data = window[availableStorage].getItem(nameKey);
  } else {
    data = await localForage.getItem(nameKey);
  }
  const jsonData = decryptData(data);
  return JSON.parse(jsonData);
};

export const removeStore = async (nameKey) => {
  logger({ title: 'STORAGE', subtitle: 'removeStore availableStorage', data: { availableStorage } });
  if (availableStorage === 'noStorage') return;
  if (availableStorage === 'sessionStorage') {
    window[availableStorage].removeItem(nameKey);
  } else {
    await localForage.removeItem(nameKey);
  }
};
